import moment from "moment";

// Patient age helpers live in their own leaf module -- utils.js pulls in
// dompurify/sentry/heic-to/lamejs/pdf-lib, and components that only need an age
// (ChatDetail's header badge, ModalCreateFollowUp) should not drag that chain in
// just to format a DOB. utils.js re-exports both for existing callers.

export const computeAge = (dob) => {
  if (dob === null || dob === "") return "";

  let age = "";

  let years = moment().diff(moment(dob, "MM/DD/YYYY"), "years", false);
  if (years < 1) {
    const months = moment().diff(moment(dob, "MM/DD/YYYY"), "months", false);
    if (months > 0)
      // ADD MONTHS
      age = months + "m";
    else age = "";

    if (months < 4) {
      // ADD DAYS
      const date = moment(dob, "MM/DD/YYYY").add(months, "months");
      const days = moment().diff(date, "days", false);
      if (days > 0) age = age + (age === "" ? "" : " ") + days + "d";
    }
  } else {
    age = years + "y";
    if (years < 3) {
      age = years + "y";

      // ADD YEARS
      const date = moment(dob, "MM/DD/YYYY").add(years, "years");
      const months = moment().diff(date, "months", false);
      if (months > 0) age += " " + months + "m";
    }
  }

  return age === "NaNy" ? "" : age; // Managed not a number
};

// The `local:userAge` context variable is a snapshot written when an encounter
// is created, and follow-ups copy it forward verbatim -- so it goes stale the
// moment the patient has a birthday. Always prefer a live computation off the
// patient's DOB; fall back to the stored string only when there is no DOB to
// compute from (anonymous/incomplete patients).
export const resolveUserAge = (dob, storedAge) => computeAge(dob) || storedAge || "";
